import React from 'react';
import { Text, Flex, Container } from '@chakra-ui/react';

import { Page } from '@/components/layout';
import SiteSearch from '@/components/ui/SiteSearch';
import { SiteSettingsType } from '@/api';
import type { FlexProps } from '@chakra-ui/react';

type Props = {
  siteSettings: SiteSettingsType;
} & FlexProps;

const Search: React.FC<Props> = ({ ...rest }) => {
  const siteSettings = { ...rest.siteSettings, mainBottomBanner: undefined };
  const pageData = {
    layerStyle: 'standard.grey.page',
    siteSettings,
  };

  return (
    <Page {...pageData}>
      <Flex
        paddingX={{ base: 6, lg: 24 }}
        display="flex"
        justifyContent="center"
        width="100%"
        minHeight="calc(100vh - 300px)"
        paddingY={{ base: 12, md: 20, xl: 32 }}
      >
        <Container maxW="container.xl">
          <Text as="h1" textStyle="h1 conversational" marginBottom={4}>
            What are you looking for?
          </Text>
          <SiteSearch />
        </Container>
      </Flex>
    </Page>
  );
};

export default Search;
